import React from "react"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "../../../hooks"
import "./wallet-balance-widget.css"

interface WalletBalanceWidgetProps {
  onDeposit: () => void
  onWithdraw: () => void
}

export function WalletBalanceWidget({ onDeposit, onWithdraw }: WalletBalanceWidgetProps) {
  const { t } = useTranslation()
  const balance = useAppSelector((state) => state.network.profile?.usdcBalance ?? 0)

  return (
    <div className="wallet-balance-widget my-container">
      <h2>{t("wallet")}</h2>
      <div className="wallet-widget-row">
        <div className="wallet-widget-balance">
          <span className="wallet-widget-amount">${balance.toFixed(2)}</span>
          <span className="wallet-widget-currency">USDC</span>
        </div>
        <div className="wallet-widget-actions">
          <button className="bubbly green small" onClick={onDeposit}>
            {t("deposit")}
          </button>
          <button className="bubbly blue small" onClick={onWithdraw}>
            {t("withdraw")}
          </button>
        </div>
      </div>
    </div>
  )
}
